import { lazy } from 'react';
export const PathJson = {
1000 : lazy (()=> import('../Pages/Home/home')),
1001 : lazy (()=> import('../Modules/MasterForms/Unit/UnitMain')),
1002 : lazy (()=> import('../Modules/MasterForms/Department/DepartmentMain')),
1003 : lazy (()=> import('../Modules/MasterForms/Employee/EmployeeMain')),
1004 : lazy (()=> import('../Modules/MasterForms/Brand/BrandMain')),
1005 : lazy (()=> import('../Modules/MasterForms/Category/CategoryMain')),
1006 : lazy (()=> import('../Modules/MasterForms/ChildProduct/ChildProductMain')),
1007 : lazy (()=> import('../Modules/MasterForms/ParentProduct/ParentProductMain')),
1009 : lazy (()=> import('../Modules/MainForms/MainParent/MainParentMain')),
1008 : lazy (()=> import('../Modules/MasterForms/AddStock/AddStockMain')),
1010 : lazy (()=> import('../Modules/MainForms/ProductSharing/ProductSharingMain')),
1011 : lazy (()=> import('../Modules/MasterForms/Customer/CustomerMain')),
1012 : lazy (()=> import('../Modules/MasterForms/ProductType/ProductTypeMain')),
1013 : lazy (()=> import('../Modules/MasterForms/OrderCreation/OrderCreationMain')),
1014 : lazy (()=> import('../Modules/MasterForms/OrderEdit/OrderEditMain')),
1015 : lazy (()=> import('../Modules/MainForms/ProductOutwards/OutwardsMain')),
1016 : lazy (()=> import('../Modules/MainForms/ProductInwards/InwardsMain')),
1017 : lazy (()=> import('../Modules/MainForms/Log/LogMain')),
1018 : lazy (()=> import('../Modules/MainForms/HeadOffice/HeadOfficeMain')),
1019 : lazy (()=> import('../Modules/MainForms/Unit1/Unit1Main')),
1020 : lazy (()=> import('../Modules/MasterForms/ItemWise/ItemWiseMain')),
1021 : lazy (()=> import('../Modules/MasterForms/OrderWise/OrderWiseMain')),
1022 : lazy (()=> import('../Modules/MainForms/MenuRegistry/MenuRegistryMain')),
1023 : lazy (()=> import('../Modules/MainForms/UserRights/UserRightsMain')),
1024 : lazy (()=> import('../Modules/MasterForms/MicroOrders/MicroOrdersMain')),
1025 : lazy (()=> import('../Modules/MasterForms/AdjustStock/AdjustStockMain')),
1026 : lazy (()=> import('../Modules/MainForms/Unit2/Unit2Main')),
1027 : lazy (()=> import('../Modules/MainForms/Unit3/Unit3Main')),
1028 : lazy (()=> import('../Modules/MasterForms/OrderUpdate/OrderUpdateMain')),
// 1029 : lazy (()=> import('../Modules/MainForms/Unit4/Unit4Main')),
// 1030 : lazy (()=> import('../Modules/MainForms/Unit5/Unit5Main')),
}